<template>
  <ChatHistory v-if="isChatAvailable && isHistoryPopupVisible" />
  <Chat
    v-if="usesAIAssistant"
    v-show="isChatVisible"
    :aria-hidden="!isChatVisible || undefined"
    class="chat-component"
  />
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import store from "../../store/index";
import Chat from "./Chat.vue";
import ChatHistory from "./ChatHistory.vue";

// The profile/settings page is excluded by product requirement.
const settingsRouteNames = ["UserProfile"];

// Authentication, registration and session flows.
const authFlowRouteNames = [
  "Login",
  "Register",
  "NoAccount",
  "ResetPassword",
  "NewPassword",
  "Mfa",
  "MfaSetup",
  "OidcAuth",
  "OidcSignOut",
  "AuthByToken",
];

// Public and one-off token pages. They are reachable without the app shell and
// most of them hide the footer as well, so the assistant has no place there.
const standaloneRouteNames = [
  "PublicNewsDetails",
  "PublicSchemeDetails",
  "OnzePublicNewsList",
  "SalesForce",
  "SalesForceCallback",
  "SalesForceUnsubscribe",
  "RatingPage",
  "ReactivationSuggestionsPage",
  "DeactivationForm",
  "NewUserSuggestionPage",
  "ImpressumPage",
  "Mailing",
];

// Error and dead-end pages.
const errorRouteNames = ["Unauthorized", "ErrorPage", "PortalExpired"];

const excludedRouteNames = new Set([
  ...settingsRouteNames,
  ...authFlowRouteNames,
  ...standaloneRouteNames,
  ...errorRouteNames,
]);

const route = useRoute();

const usesAIAssistant = computed(() => {
  const authUser = store.state.auth.authUser;

  return !!(authUser.userUsesAIAssistant || authUser.usesAIAssistant);
});

const isHistoryPopupVisible = computed(
  () => store.state.chat.isHistoryPopupVisible,
);

const isRouteAllowed = computed(
  () =>
    // "/" is the unnamed login route.
    route.path !== "/" && !excludedRouteNames.has(route.name),
);

const isChatAvailable = computed(
  () => usesAIAssistant.value && isRouteAllowed.value,
);

const isChatVisible = computed(
  () => isRouteAllowed.value && !isHistoryPopupVisible.value,
);
</script>
